import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/WXJSDK/GetNoCookieUserId',
    method: 'post',
    data
  });
}

export function UserLogin(data) {
  return request({
    url: '/Home/UserLogin',
    method: 'post',
    data
  });
}

export function NewUser(data) {
  return request({
    url: '/System/NewUser',
    method: 'post',
    data
  });
}

export function logout() {
  return request({
    url: '/Home/logout',
    method: 'post'
  })
}

